const tools = {
  ucFirst: function (params) {
    var str = params.toLowerCase();
    var strArr = str.split(" ");
    var result = "";
    for (var i in strArr) {
      result +=
        strArr[i].substring(0, 1).toUpperCase() + strArr[i].substring(1) + " ";
    }
    return result;
  },
  isWeixin: function () {
    if (
      navigator &&
      navigator.userAgent &&
      navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1
    ) {
      return true;
    }
    return false;
  },
  parseQuery: function (data) {
    let res = {};

    // 你提供的 URL
    const httpUrl = data;

    // 使用 URLSearchParams 解析查询字符串
    const url = new URL(httpUrl);
    const params = new URLSearchParams(url.search);

    // 获取 'code' 参数的值
    res.code = params.get("code");

    // 返回结果
    return res;
  },
};

export default tools;
